import { render, staticRenderFns } from "./couriers.vue?vue&type=template&id=73b3c3e7&scoped=true&"
import script from "./couriers.js?vue&type=script&lang=js&"
export * from "./couriers.js?vue&type=script&lang=js&"
import style0 from "./couriers.scss?vue&type=style&index=0&id=73b3c3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3c3e7",
  null
  
)

export default component.exports